/*
  STAEY BLACK WEEK 2026 (Claude 03-11)
  - [data-bw26-countdown="ISO-tid"]: tæller dage/timer/minutter/sekunder ned. Med data-bw26-hide-after skjules
    hele sektionen, når tiden er nået.
  - [data-bw26-signup]: VIP-tilmelding direkte til Klaviyo (client/subscriptions, som Luksushunds Black November-side).
    data-closes="ISO-tid" (valgfri) skifter formularen ud med lukketeksten efter det tidspunkt.
  Virker også, når sektionerne genindlæses i temaeditoren.
*/
(() => {
  // Hver bw26-sektion indlæser filen; kun første gang gør noget
  if (window.bw26Loaded) return;
  window.bw26Loaded = true;

  const pad = n => String(n).padStart(2, '0');

  function startCountdown(root) {
    if (root.bw26Timer) clearInterval(root.bw26Timer);
    const target = Date.parse(root.dataset.bw26Countdown);
    if (Number.isNaN(target)) return;
    const nums = {};
    root.querySelectorAll('[data-unit]').forEach(el => { nums[el.dataset.unit] = el; });
    const section = root.closest('.shopify-section') || root;

    const tick = () => {
      const left = target - Date.now();
      if (left <= 0) {
        clearInterval(root.bw26Timer);
        Object.values(nums).forEach(el => { el.textContent = '00'; });
        if (root.hasAttribute('data-bw26-hide-after') && !window.Shopify?.designMode) section.hidden = true;
        return;
      }
      const s = Math.floor(left / 1000);
      const values = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
      for (const k in values) {
        const v = pad(values[k]);
        if (nums[k] && nums[k].textContent !== v) nums[k].textContent = v;
      }
    };
    tick();
    root.bw26Timer = setInterval(tick, 1000);
  }

  const validEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);

  function initSignup(root) {
    const form = root.querySelector('[data-bw26-form]');
    const open = root.querySelector('[data-bw26-open]');
    const done = root.querySelector('[data-bw26-done]');
    const closed = root.querySelector('[data-bw26-closed]');
    const errorEl = root.querySelector('[data-bw26-error]');
    if (!form || form.dataset.bw26Ready) return;
    form.dataset.bw26Ready = '1';

    const closes = Date.parse(root.dataset.closes || '');
    if (!Number.isNaN(closes) && Date.now() >= closes) {
      open.hidden = true;
      closed.hidden = false;
      return;
    }

    const email = form.querySelector('[name="email"]');
    const name = form.querySelector('[name="first_name"]');
    const button = form.querySelector('[type="submit"]');

    const clearError = field => {
      field.closest('[data-field]')?.classList.remove('is-invalid');
      errorEl.textContent = '';
    };
    email.addEventListener('input', () => clearError(email));
    name?.addEventListener('input', () => clearError(name));

    async function subscribe(data) {
      const { company, list, source, country, language, market } = root.dataset;
      const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(company)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: {
              email: data.email,
              first_name: data.first_name || undefined,
              properties: { bw26_country: country, bw26_language: language, bw26_market: market }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        } })
      });
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
    }

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.getAttribute('aria-busy') === 'true') return;

      const data = { email: email.value.trim(), first_name: name ? name.value.trim() : '' };
      if (name && !data.first_name) {
        name.closest('[data-field]').classList.add('is-invalid');
        errorEl.textContent = root.dataset.msgName;
        name.focus();
        return;
      }
      if (!validEmail(data.email)) {
        email.closest('[data-field]').classList.add('is-invalid');
        errorEl.textContent = root.dataset.msgEmail;
        email.focus();
        return;
      }

      button.setAttribute('aria-busy', 'true');
      try {
        await subscribe(data);
        open.hidden = true;
        done.hidden = false;
        done.focus({ preventScroll: true });
        window.dataLayer?.push({ event: 'bw26_vip_signup', bw26_market: root.dataset.market });
      } catch (err) {
        errorEl.textContent = root.dataset.msgFailed;
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-bw26-countdown]').forEach(startCountdown);
    scope.querySelectorAll('[data-bw26-signup]').forEach(initSignup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
